import { useState, useEffect } from "react";
import { loadIssueIndentList } from "../services/issueIndentService";

const useIssueIndentList = (Mode) => {
    const [issuedIndentList, setIssuedIndentList] = useState([]);
    const [selectIssuedIndent, setSelectedIssuedIndent] = useState(null);
    const [selectIssuedIndentID, setSelectedIssuedIndentID] = useState(null);
    const [isIssuedIndentDataLoaded, setIsIssuedIndentDataLoaded] = useState(false);

    // Fetch department data
    const fetchIssuedIndent = async (selectedID = null) => {
        const para = { p_company_id: localStorage.getItem("companyid"), p_plant_id: 1,p_select_status:Mode };

        try {
            const data = await loadIssueIndentList(para);
            if (data && data.length > 0) {
                setIssuedIndentList(data);
                setIsIssuedIndentDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isIssuedIndentDataLoaded) {
            fetchIssuedIndent();
        }
    }, [isIssuedIndentDataLoaded]);

    // Function to load department based on selected ID
    const loadIssuedIndentByID = async (selectedID) => {
        await fetchIssuedIndent(selectedID);
    };

    return {
        issuedIndentList,
        setIssuedIndentList,
        selectIssuedIndent,
        selectIssuedIndentID,
        loadIssuedIndentByID,
    };
};

export default useIssueIndentList;
